import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { ThemeIcon, Interactable, Text, View } from '@24i/nxg-sdk-quarks';
import React from 'react';
import { SEARCH_RECENT_TEST_IDS } from '../../../types';
import getSearchDropdownItemStyles from '../styles';
import { SearchDropdownItemProps } from './types';

const noop = () => {};

const SearchDropdownItem = ({
    item = '',
    onDropdownItemPress = noop,
    onRemovePress = noop,
    styles: getStyles = getSearchDropdownItemStyles,
    testID = '',
}: SearchDropdownItemProps) => {
    const { theme } = useTheme();
    const styles = getStyles(theme);

    return (
        <View testID={testID} style={styles.container}>
            <Interactable onPress={() => onDropdownItemPress(item)} style={styles.button}>
                <ThemeIcon
                    iconName="onPrimary-expiration"
                    size={20}
                    iconStyles={styles.dropdownItemIcon}
                />

                <Text
                    numberOfLines={1}
                    style={styles.text}
                    testID={SEARCH_RECENT_TEST_IDS.SEARCH_RECENT_TEXT}
                >
                    {item}
                </Text>
            </Interactable>
            <Interactable
                testID={SEARCH_RECENT_TEST_IDS.SEARCH_RECENT_X_BUTTON}
                onPress={() => onRemovePress(item)}
                style={styles.interectable}
            >
                <ThemeIcon
                    iconName="onPrimary-clear"
                    size={20}
                    iconStyles={styles.dropdownItemIcon}
                />
            </Interactable>
        </View>
    );
};

export { getSearchDropdownItemStyles };

export default overridable(SearchDropdownItem, 'SearchDropdownItem');
